import { Component } from "@angular/core";
import { Router } from "@angular/router";
@Component({
  template: `
    <div class="wgu-container">
      <h2>Account Setup Canceled</h2>

      <p class="mb-6">
        You have canceled the account setup process, and your account has not
        been set up. If you have questions or are having difficulty setting up
        your account, please contact the IT Service Desk at
        <a>servicedesk&#64;wgu.edu</a> or (877) 435-7948.
      </p>

      <p class="mb-6">
        You have canceled the account setup process, and your account has not
        been set up.
      </p>

      <p class="mb-6">
        If you have questions or are having difficulty setting up your account,
        please contact the IT Service Desk at servicedesk&#64;wgu.edu or (877)
        435-7948.
      </p>

      <div><a href="/" class="wgu-btn">Try again</a></div>
    </div>
  `,
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
      .error input {
        background-color: #e3c3c5;
      }
      .error ::-webkit-input-placeholder {
        color: #999;
      }
      .error :-moz-placeholder {
        color: #999;
      }
      .error ::-moz-placeholder {
        color: #999;
      }
      .error :ms-input-placeholder {
        color: #999;
      }
    `,
  ],
})
export class CancelPageComponent {
  mouseoverLogin;

  constructor(private router: Router) {}
}
